import { graphql } from '@/gql/client';

export const EventFieldsFragment = graphql(`
  fragment EventFieldsFragment on Event {
    ...EventSummaryFieldsFragment
    content
    seo {
      ...PostTypeSeoFieldsFragment
    }
    pageCustomFields {
      sidetext {
        text
        placement
      }
      enableOverlayNavbar
      enableLines
      theme
      hideFooterDivider
      hideSidetext
    }
  }
`);
